<template>
  <seats-booking title="Bike Indoor" :seats-type="SeatsType.gym"></seats-booking>
</template>

<script lang="ts">
import {defineComponent} from 'vue'
import SeatsBooking from "@/components/SeatsBooking.vue";
import { SeatsType } from '@/models.ts'
export default defineComponent({
  components: {SeatsBooking},
  setup() {
    return {
      SeatsType,
    }
  }
})
</script>


<style scoped>

</style>